import { format, utcToZonedTime } from 'date-fns-tz';
import { sub as subDate } from 'date-fns';

import { COMPLIANCE_PERIOD_IN_DAYS, DateDisplayFormats } from '@/constants';

const utcTimeZone = 'Etc/UTC';

export function formatDateForDisplay(
  date: string | number | Date,
  // eslint-disable-next-line max-len
  pattern: typeof DateDisplayFormats[keyof typeof DateDisplayFormats] = DateDisplayFormats.NUMERIC_DATE
): string {
  // NOTE: while this says utcToZonedTime, a `Date` has no concept of timezone
  // so this library function should really just be called `toZonedTime`
  // NOTE: We shouldn't wrap `date` in a `Date` constructor, instead we should
  // remap all API dates to the `Date` type. We have to do this as the date-fns
  // `format` func will only accept `Date | number` for its `date` argument.
  const utcDate = utcToZonedTime(date instanceof Date ? date : new Date(date), utcTimeZone);
  return format(utcDate, pattern, { timeZone: utcTimeZone });
}

// Return a label for a given date, and the compliance date range ending on
// the given date.
export function selectedDateLabels(timestamp?: Date, isInterim?: boolean) {
  const labelFormat = isInterim
    ? DateDisplayFormats.WORD_MONTH_WITH_DAY_AND_TIME_RANGE
    : DateDisplayFormats.WORD_MONTH_WITH_DAY;

  const timestampLabel = timestamp
    ? `${formatDateForDisplay(timestamp, labelFormat)}${isInterim ? ' (UTC)' : ''}`
    : '';

  const rangeStart = timestamp
    ? subDate(timestamp, { days: COMPLIANCE_PERIOD_IN_DAYS - (isInterim ? 0 : 1) })
    : new Date();

  const rangeStartLabel = timestamp ? formatDateForDisplay(rangeStart, labelFormat) : '';
  const rangeLabel =
    rangeStartLabel !== '' && timestampLabel !== ''
      ? `${
          isInterim && rangeStart
            ? formatDateForDisplay(rangeStart, DateDisplayFormats.WORD_MONTH_WITH_DAY_AND_TIME)
            : rangeStartLabel
        } - ${
          isInterim && timestamp
            ? `${formatDateForDisplay(
                timestamp,
                DateDisplayFormats.WORD_MONTH_WITH_DAY_AND_TIME
              )} (UTC)`
            : timestampLabel
        }`
      : '';

  return {
    timestampLabel,
    rangeLabel,
  };
}
